$(document).on('click', '.ap-tooltip', function() {
  let toolText = $(this).closest('.ap-label-tooltip').find('label').find('.apo-title').text().toLowerCase();

  if (toolText.includes('light')) {
    document.querySelector('a[data-target*="light"]').click();
  } else if (toolText.includes('floor')) {
    document.querySelector('a[data-target*="floor"]').click();
  } else if (toolText.includes('header')) {
    document.querySelector('a[data-target*="header"]').click();
  } else if (toolText.includes('double')) {
    document.querySelector('a[data-target*="double"]').click();
  } else if (toolText.includes('design')) {
    document.querySelector('a[data-target*="design"]').click();
  } else if (toolText.includes('transport') || toolText.includes('podium')) {
    document.querySelector('a[data-target*="transpot"]').click();
  } else if (toolText.includes('alive')) {
    document.querySelector('a[data-target*="alive"]').click();
  }
});